const beforeUnloadListener = (event) => {
	event.preventDefault();
	return (event.returnValue = `Are you sure you want to exit?`);
};

export function addBeforeUnloadListener() {
	addEventListener(`beforeunload`, beforeUnloadListener, { capture: true });
}
export function removeBeforeUnloadListener() {
	removeEventListener(`beforeunload`, beforeUnloadListener, { capture: true, });
}